export default __webpack_public_path__ + "static/media/cp_geo_dm.29411c9a.svg";